module.exports = __webpack_public_path__ + "img/logo-dark.da235529.png";